import { reactive, ref, watch, watchEffect } from 'vue'

import { Config } from '../config/config'
import { Language } from '../config/language'
import { createGlobalState, useStorage } from '@vueuse/core';
import { ConfigDefault } from '@/config/configdefaults';
import { isInIframe } from '@/helpers/iframe';
import { useRefOrLocalStorage } from '@/helpers/reforstorage';

const config = reactive(new Config()) as Config;
const lng = reactive(new Language()) as Language;

config.init();

/*
 * Reachable from the browser console, like state and videobridge are. Handy for the
 * settings that have no place in the options dialog: assigning to it goes through the
 * reactive proxy, so the watch below picks the change up and writes it to storage.
 */
(window as any).config = config;

// keep track of changes in the config
const configVersion = useStorage('config-version', 1);

export const useCore = createGlobalState(() => {
    const isMaster = ref(false);

    // All changes to the master config (the one in the main window),
    // will be written to localStorage.
    watch(config, () => {
        if (isMaster.value) {
            config.write();
            configVersion.value += 1;
        }
    });

    // All changes written to the localStorage will be read automatically
    // in all the sub windows (non master editions)
    watch(configVersion, () => {
        if (!isMaster.value) {
            config.read();
        }
    });

    /**
     * The global zoom factor.
     * You can use useAutoZoom to have the screen automatically zoom out when
     * screen is too small.
     */
    const zoom = useRefOrLocalStorage('Zoom', 1.0);

    if (isInIframe()) {
        console.debug('we are iframed!');
        config.fontSize = ConfigDefault.fontSize;
        config.autoZoom = false;
        config.fontWeight = ConfigDefault.fontWeight;
    } else {
        // This will auto zoom and use config.fontSize for display size. (Zooming)
        watchEffect(() => {
            // useAutoZoom already keeps this within MIN_ZOOM..MAX_ZOOM; clamping again
            // here would undo the room to grow above 1.
            const fs = config.autoZoom ? config.fontSize * zoom.value : config.fontSize;

            document.documentElement.style.fontSize = fs.toString() + "px";
        });
    }


    return { config, lng, isMaster, zoom }
});


